import moment from "moment-timezone";

export const initialState: State = {
    to: undefined,
    link: undefined,
    startDate: moment().add(-7, 'days').hours(0).startOf('hour'),
    endDate: moment().hours(23).endOf('hour'),
    currentList: [],
    page: 1,
    pageCount: 1,
    totalCount: 1,
    pageLoading: true,
    displayLoading: true,
    contentLoading: false
};

export interface State {
    to: string | undefined;
    link: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    currentList: ContentItem[];
    page: number;
    pageCount: number;
    totalCount: number;
    pageLoading: boolean;
    displayLoading: boolean;
    contentLoading: boolean;
}

export interface FilterChanges {
    to?: string;
    link?: string;
    startDate: moment.Moment;
    endDate: moment.Moment;
}

export interface ContentItem {
    dateSent: string;
    sender: string;
    recipient: string;
    landingPage: string;
    templateName: string;
    dateClicked: string;
    ref: string;
}